import React from 'react';
import Helmet from 'react-helmet';
import BasicComponent from './components/basic';
import Header from './components/layout/header';
import Footer from './components/layout/footer';
import Loader from './components/layout/loader';
import Phone from './components/phone/phone';
import InitForm from './components/form/init';
import Introduce from './components/layout/introduce';
import Code from './components/result/code';
import ResultTitle from './components/result/title';
import ResultError from './components/result/error';
import ReactGA from 'react-ga';

export default class App extends BasicComponent {

  static get STATUS_INIT() {return 'init';}
  static get STATUS_PROCESSING() {return 'processing';}
  static get STATUS_ERROR() {return 'error';}
  static get STATUS_DONE() {return 'done';}

  constructor(props) {
    super(props);
    this.state = {
      status: App.STATUS_INIT,
      originalUrl: null,
      connectionResultTimeoutId: null,
      client: null,
      requestId: null,
      ampUrl: null,
      ampGoogleCacheUrl: null,
      ampNoticeList: [],
      errorList: [],
      currentLocale: this.props.locale,
      disableSubscribe: true
    };
    this.startProcess = this.startProcess.bind(this);
    this.changeLocale = this.changeLocale.bind(this);
    ReactGA.initialize(this.props.gaCode, {
      debug: !!this.props.debugMode,
      titleCase: false
    });
  }
  componentDidMount() {
    let { hash } = this.props;
    ReactGA.pageview(window.location.pathname + window.location.search);
    if (hash) {
      if (this.isValidURL(hash)) {
        setTimeout(()=>this.startProcess(hash));
      }
    } else {
      ReactGA.event({
        category: 'rabbit_generator',
        action: 'view',
        label: 'top',
        nonInteraction: true
      });
    }
  }

  componentWillUpdate(nextProps, nextState) {
    if (this.state.status !== nextState.status) {
      let label;
      switch (nextState.status) {
        case App.STATUS_PROCESSING:
          label = 'loading';
        break;
        case App.STATUS_ERROR:
          label = 'error';
        break;
        case App.STATUS_DONE:
          label = 'result';
        break;
        default:
          label = null;
        break;
      }
      if (label) {
        ReactGA.event({
          category: 'rabbit_generator',
          action: 'view',
          label: label,
          nonInteraction: true
        });
      }
    }
  }

  render() {
    let {T} = this.props;
    return (
      <div>
          <Helmet>
            <html lang={T.translate('lang')}/>
            <title>{T.translate('title')}</title>
            <link rel="alternate" href={`${this.props.langUrl}#en`} hreflang="en" />
            <link rel="alternate" href={`${this.props.langUrl}#ja`} hreflang="ja" />
            <meta name="description" content={T.translate('meta.description')}/>
            <meta name="keywords" content={T.translate('meta.keywords')}/>
            <meta name="viewport" content="width=device-width, initial-scale=1.0, user-scalable=no, minimum-scale=1.0, maximum-scale=1.0" />
            <meta http-equiv="X-UA-Compatible" content="IE=edge"/>
            <meta property="og:type" content="website"/>
            <meta property="og:title" content={T.translate('title')}/>
            <meta property="og:description" content={T.translate('meta.description')}/>
            <meta property="og:image" content={T.translate('meta.image')} />
            <meta property="og:url" content="https://generator.rabbit.gomobile.jp/" />
            <meta property="og:site_name" content={T.translate('title')}/>
            <meta property="fb:app_id" content="148089798643738" />
            <meta name="twitter:card" content="summary" />
            <meta name="twitter:url" content="https://generator.rabbit.gomobile.jp/" />
            <meta name="twitter:title" content={T.translate('title')} />
            <meta name="twitter:description" content={T.translate('meta.description')} />
            <meta name="twitter:image" content={T.translate('meta.image')} />
            <meta name="twitter:site" content="@i3design_jp" />
          </Helmet>
        {!~[App.STATUS_PROCESSING].indexOf(this.state.status) && <Header T={T} listLocale={this.props.listLocale} changeLocale={this.changeLocale} currentLocale={this.state.currentLocale}/>}
        <main className={this.getMainPageClassName()}>
          {!!~[App.STATUS_PROCESSING].indexOf(this.state.status) && <Loader T={T}/>}
          <div className="wrapper">
          {!!~[App.STATUS_DONE].indexOf(this.state.status) && <ResultTitle originalUrl={this.state.originalUrl} isError={false} T={T}/>}
          {!!~[App.STATUS_ERROR].indexOf(this.state.status) && <ResultTitle originalUrl={this.state.originalUrl} isError={true} T={T}/>}
          {!!~[App.STATUS_ERROR].indexOf(this.state.status) && <ResultError list={this.state.errorList} T={T}/>}
          {!!~[App.STATUS_DONE, App.STATUS_INIT].indexOf(this.state.status) && <Phone ampUrl={this.state.ampGoogleCacheUrl || this.state.ampUrl} originalUrl={this.state.originalUrl}/>}
          {!!~[App.STATUS_DONE].indexOf(this.state.status) && <Code ampUrl={this.state.ampUrl} noticeList={this.state.ampNoticeList} T={T}/>}
          {!!~[App.STATUS_INIT].indexOf(this.state.status) && <InitForm appStartHandler={this.startProcess} position="right" T={T}/>}
          </div>
          {!!~[App.STATUS_DONE].indexOf(this.state.status) && <Introduce T={T} status={this.state.status}/>}
          {!!~[App.STATUS_DONE, App.STATUS_ERROR].indexOf(this.state.status) && <InitForm appStartHandler={this.startProcess} position="bottom" T={T}/>}
          {!!~[App.STATUS_ERROR].indexOf(this.state.status) && <Introduce T={T} status={this.state.status}/>}
        </main>
        {!~[App.STATUS_PROCESSING].indexOf(this.state.status) && <Footer mailchimpUrl={this.props.mailchimpUrl} T={T} disableSubscribe={this.state.disableSubscribe}/>}
      </div>
    );
  }

  changeLocale(locale) {
    locale = this.props.setAppLocale(locale)
    this.setState({
      currentLocale: locale
    })
  }

  isValidURL(url) {
    return /^(https?):\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!$&'()*+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!$&'()*+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!$&'()*+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!$&'()*+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!$&'()*+,;=]|:|@)|\/|\?)*)?$/i.test(url);
  }

  processApiRequest() {
    let self = this;
    let client = self.state.client;
    if (client && client.state === 'connected') {
      self.callApiRequest();
    } else {
      try {
        client = new window.ActionheroWebsocketClient({
          url: self.props.apiURL
        })
        self.setState({client}, () => {
          const client = self.state.client;
          client.on('connected', () => {
            self.log('api', 'connected', client.id);
          });
          client.on('disconnected', () => {
            self.log('api', 'disconnected', client.id);
            self.state.status === App.STATUS_PROCESSING && self.processError(['network error']);
          });
          client.on('reconnecting', () => {
            self.log('api', 'reconnecting', client.id);
          });
          client.on('reconnect', () => {
            self.log('api', 'reconnect', client.id);
          });
          client.on('error', (error) => {
            self.error('api', 'error', client.id, error);
            self.processError(['network error']);
          });
          client.on('message', (message) => {
            self.log('api', 'message', client.id, message);
            self.processApiResponse(message);
          });
          client.connect((error, details) => {
            if (error) {
              self.error('api', 'error', client.id, error);
              self.processError(['network error']);
            } else {
              self.callApiRequest();
            }
          })
        })
      } catch (e) {
        self.processError(['internal connection error']);
      }
    }
    this.startTimeoutMonitoring();
  }

  callApiRequest() {
    if (this.state.status === App.STATUS_PROCESSING) {
      try {
        this.state.client.action('ampGenerate', {
          url: this.state.originalUrl,
          locale: this.state.currentLocale,
          initiator: 'Rabbit AMP Generator',
          timezone: 'Asia/Tokyo'
        });
      } catch (e) {
        this.processError(['internal connection error']);
      }
      this.state.originalUrl && ReactGA.event({
        category: 'rabbit_generator',
        action: 'request',
        label: this.state.originalUrl,
        nonInteraction: true
      });
    }
  }

  getMainPageClassName() {
    let className = 'main-page'
    switch (this.state.status) {
      case App.STATUS_PROCESSING:
        className = 'loading-page';
      break
      case App.STATUS_ERROR:
      case App.STATUS_DONE:
        className = 'main-page result-page';
      break
      default:
        className = 'main-page';
      break
    }
    return className;
  }

  startProcess(url) {
    window.scrollTo(0, 0);
    this.setState({
      status: App.STATUS_PROCESSING,
      originalUrl: url,
      ampUrl: null,
      ampGoogleCacheUrl: null,
      requestId: null,
      noticeList: []
    }, this.processApiRequest);
  }

  processApiResponse(message) {
    if (message && message.context && message.context === 'response') {
      if (message.error) {
        this.processError([message.error]);
      } else if (message.id) {
        switch (message.status) {
          case 'inqueue':
            this.state.status === App.STATUS_PROCESSING && this.setState({
              requestId: message.id
            })
          break;
          case 'done':
          case 'cache':
            if (!this.state.requestId || this.state.requestId === message.id) {
              if (message.errorList && message.errorList.length) {
                this.processError(message.errorList);
              } else {
                this.setState({
                  status: App.STATUS_DONE,
                  ampUrl: message.ampUrl,
                  ampGoogleCacheUrl: message.ampGoogleCacheUrl,
                  ampNoticeList: message.noticeList
                }, this.stopTimeoutMonitoring);
                ReactGA.event({
                  category: 'rabbit_generator',
                  action: 'response',
                  label: (message.ampUrl || '').substring(0, 500),
                  nonInteraction: true
                });
              }
            }
          break;
          default:
          break;
        }
      }
    }
  }

  processError(errorList) {
    this.setState({
      status: App.STATUS_ERROR,
      errorList: errorList
    }, this.stopTimeoutMonitoring);
    ReactGA.event({
      category: 'rabbit_generator',
      action: 'error',
      label: (errorList || []).join(',').substring(0, 500),
      nonInteraction: true
    });
  }

  processTimeout() {
    this.processError(['connection timeout']);
    try {
      this.state.client && this.state.client.disconnect();
    } catch (e) {}
  }

  startTimeoutMonitoring() {
    this.stopTimeoutMonitoring();
    this.setState({
      connectionResultTimeoutId: setTimeout(this.processTimeout.bind(this), this.props.responseTimeout || 300000)
    });
  }

  stopTimeoutMonitoring() {
    this.state.connectionResultTimeoutId && clearTimeout(this.state.connectionResultTimeoutId);
    this.setState({
      connectionResultTimeoutId: null
    });
  }
}



// WEBPACK FOOTER //
// ./src/app.js